import type { App } from 'vue';

import CAlert from './CAlert.vue';
import CCallout from './CCallout.vue';
import CCard from './CCard.vue';
import CCardBody from './CCardBody.vue';
import CCardFooter from './CCardFooter.vue';
import CCardHeader from './CCardHeader.vue';
import CContainer from './CContainer.vue';

/**
 * Sostituti locali dei componenti CoreUI, al posto di `@coreui/vue`.
 *
 * **Perche non aggiornare `@coreui/vue` alla 5.** La 3 dipende da Vue 2, quindi restare fermi non
 * era possibile; ma la 5 e costruita su **Bootstrap 5**, che rinomina le utility - `ml-` diventa
 * `ms-`, `mr-` diventa `me-`, `text-left` diventa `text-start`. Il progetto ne usa 180 occorrenze in
 * 67 file, e in piu `assets/scss/vendor/_coreui.scss` (88 righe) e scritto sull'API Sass di CoreUI 3.
 * Sarebbe stata una seconda migrazione, con effetti visivi che i test end-to-end non vedono: quelli
 * guardano ruoli e testo, non pixel.
 *
 * **Cosa sono davvero questi componenti.** Il 95% dell'uso (299 occorrenze su 320) e la famiglia
 * `CCard`, che sono involucri di tre righe attorno a `<div class="card">`. Riscriverli qui costa meno
 * che migrare Bootstrap, **lascia i 320 punti d'uso invariati** - `class`, `v-if` e la direttiva
 * `v-loading` continuano ad arrivare per ricaduta degli attributi - e la resa visiva resta identica,
 * perche il CSS sotto non cambia.
 *
 * Restano quindi in progetto `@coreui/coreui` 3 (solo fogli di stile, nessuna dipendenza da Vue) e
 * `bootstrap` 4. Esce `@coreui/vue`.
 *
 * I componenti del guscio - barra laterale, intestazione, tendine - non sono qui: erano una manciata
 * di occorrenze in quattro file e sono stati riscritti direttamente, usando `el-dropdown` di
 * element-plus dove serviva un comportamento e non solo un contenitore.
 */
const initCoreUi = (app: App) => {
  const componenti = { CAlert, CCallout, CCard, CCardBody, CCardFooter, CCardHeader, CContainer };
  Object.entries(componenti).forEach(([nome, componente]) => app.component(nome, componente));
};

export default initCoreUi;
